













































import Vue from "vue";
import { jobModalService } from "@/services/modal-service.ts";
import { getJobOpenings } from "@/resources/content/jobOpenings.ts";

export default Vue.extend({
  name: "JobModalPopup",
  data() {
    return {
      showModal: false,
      centerContent: true,
      currentJob: <any>{},
    };
  },
  created() {
    this.$subscribeTo(jobModalService.listenJobModal(), (id: number) => {
      if (!id && id !== 0) return;
      this.showModal = true;
      this.currentJob = getJobOpenings().find((job) => job.id === id);

      this.$nextTick(() => {
        this.showContentInMidle();
      });
    });
  },
  methods: {
    showContentInMidle() {
      const content: any = this.$refs["modal-content"];
      const contentHeight = content.offsetHeight + 160;
      const screenHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

      this.centerContent = contentHeight < screenHeight;
    },
    closeModal(event: any) {
      const targetName = event.target.className;

      if (targetName === "modal") {
        this.showModal = false;
      }
    },
  },
});
